import { SearchOutlined, SyncOutlined } from '@ant-design/icons'
import { Button, DatePicker, Input, Select, Space, Spin } from 'antd'
import cx from 'classnames'
import dayjs from 'dayjs'

import type { FiltersProps } from '../types'

export function Filters({
  filters,
  groups,
  groupsLoading,
  isRefreshing,
  showDateFilters = true,
  groupSearchValue,
  onGroupSearch,
  onGroupChange,
  onDateFromChange,
  onDateToChange,
  onCheckNumberChange,
  onRefresh
}: FiltersProps): React.ReactNode {
  return (
    <div className='flex flex-wrap gap-4 items-end p-4 border-b'>
      <div className='flex flex-col gap-1'>
        <label className='text-xs font-medium text-gray-500 uppercase'>Group</label>
        <Select
          placeholder='Search and select group'
          className='w-[500px]'
          loading={groupsLoading}
          value={filters.groupNumber ?? 'all'}
          onChange={value => onGroupChange(value === 'all' ? undefined : value)}
          showSearch
          filterOption={false}
          searchValue={groupSearchValue}
          onSearch={onGroupSearch}
          notFoundContent={
            groupsLoading ? (
              <div className='flex justify-center py-2'>
                <Spin size='small' />
              </div>
            ) : (
              'No groups found'
            )
          }
          options={[
            { value: 'all', label: 'All Groups' },
            ...(groups?.map(g => ({
              value: g.number,
              label: `${g.number} - ${g.name}`
            })) ?? [])
          ]}
        />
      </div>

      {showDateFilters && (
        <>
          <div className='flex flex-col gap-1'>
            <label className='text-xs font-medium text-gray-500 uppercase'>Check Date</label>
            <DatePicker
              value={filters.dateFrom ? dayjs(filters.dateFrom) : null}
              onChange={date => onDateFromChange(date?.format('YYYY-MM-DD'))}
              allowClear
            />
          </div>

          <div className='flex flex-col gap-1'>
            <label className='text-xs font-medium text-gray-500 uppercase'>To</label>
            <DatePicker
              value={filters.dateTo ? dayjs(filters.dateTo) : null}
              onChange={date => onDateToChange(date?.format('YYYY-MM-DD'))}
              allowClear
            />
          </div>
        </>
      )}

      <div className='flex flex-col gap-1'>
        <label className='text-xs font-medium text-gray-500 uppercase'>Check #</label>
        <Input
          placeholder='Search check number'
          className='w-40'
          prefix={<SearchOutlined className='text-gray-400' />}
          value={filters.checkNumber}
          onChange={e => onCheckNumberChange(e.target.value || undefined)}
          allowClear
        />
      </div>

      <Space>
        <Button
          type='default'
          disabled={isRefreshing}
          onClick={onRefresh}
          icon={<SyncOutlined className={cx(isRefreshing && 'animate-custom-spin')} />}
        >
          Refresh
        </Button>
      </Space>
    </div>
  )
}
